/* Ricamo addon — Opzione A (add-on, niente variante)
 * ---------------------------------------------------------------------------
 * Il ricamo è un servizio, NON un'opzione variante: così le scorte del capo
 * (es. boxer bianco S) restano condivise.
 *
 * Comportamento:
 *  - Una checkbox "Aggiungi ricamo" mostra/nasconde il campo testo (iniziali).
 *  - Quando il ricamo è attivo, al submit del form prodotto intercettiamo
 *    l'invio e aggiungiamo al carrello DUE righe in un'unica chiamata:
 *      1) il capo, con la property testo (es. "Ricamo": "ABC");
 *      2) il prodotto add-on "Ricamo" (prezzo extra), qty allineata al capo.
 *  - Il carrello viene poi aggiornato/aperto tramite gli eventi nativi del tema
 *    (window.themeCore.EventBus: "cart:refresh" + "cart:drawer:open").
 *
 * Il tema delega il submit con document.addEventListener("submit", ...) in
 * bubble phase; noi ascoltiamo in CAPTURE phase per girare prima e prevenirlo.
 * ---------------------------------------------------------------------------
 */
(function () {
	'use strict';

	var PRODUCT_FORM_SELECTOR = 'form[action*="/cart/add"], form.shopify-product-form, form[data-js-product-form]';

	function getBlock(form) {
		return form ? form.querySelector('.js-custom-field-block') : null;
	}

	function getToggle(block) {
		return block ? block.querySelector('.js-ricamo-toggle') : null;
	}

	function isActive(block) {
		var t = getToggle(block);
		return !!(t && t.checked);
	}

	/* ----- Mostra/nascondi il campo testo in base alla checkbox ----- */
	function syncBlock(block) {
		if (!block) return;
		var toggle = getToggle(block);
		var fields = block.querySelector('.js-ricamo-fields');
		var input = block.querySelector('.js-custom-field-input');
		if (!toggle || !fields) return;

		if (toggle.checked) {
			fields.style.display = '';
			fields.removeAttribute('aria-hidden');
			if (input) {
				input.disabled = false; // ora viene inviato come property
				input.focus();
			}
		} else {
			fields.style.display = 'none';
			fields.setAttribute('aria-hidden', 'true');
			if (input) {
				input.value = '';
				input.disabled = true; // non inviare alcuna property
			}
			clearError(block);
		}

		// Sicurezza: il checkout dinamico ("Acquista ora") bypassa il submit del
		// form, quindi salterebbe l'add-on. Lo nascondiamo quando il ricamo è attivo.
		var dynamic = block.closest('form') && block.closest('form').querySelector('.shopify-payment-button');
		if (dynamic) dynamic.style.display = toggle.checked ? 'none' : '';
	}

	function showError(block) {
		var err = block.querySelector('.js-custom-field-error');
		var input = block.querySelector('.js-custom-field-input');
		if (err) err.classList.add('is-visible');
		if (input) {
			input.classList.add('has-error');
			input.focus();
		}
	}

	function clearError(block) {
		var err = block.querySelector('.js-custom-field-error');
		var input = block.querySelector('.js-custom-field-input');
		if (err) err.classList.remove('is-visible');
		if (input) input.classList.remove('has-error');
	}

	/* ----- Costruisce gli item (capo + add-on) dal FormData ----- */
	function buildItems(form, block) {
		var fd = new FormData(form);
		var mainId = fd.get('id');
		if (!mainId) return null;
		var qty = parseInt(fd.get('quantity'), 10);
		if (!qty || qty < 1) qty = 1;

		var props = {};
		fd.forEach(function (value, key) {
			var m = key.match(/^properties\[(.+)\]$/);
			if (m && String(value).trim() !== '') props[m[1]] = value;
		});

		var items = [{ id: mainId, quantity: qty, properties: props }];

		var addonId = (block.getAttribute('data-ricamo-addon-variant') || '').trim();
		if (addonId) {
			items.push({
				id: addonId,
				quantity: qty,
				properties: { '_Ricamo per': String(mainId) }
			});
		}
		return items;
	}

	function refreshCart() {
		var bus = window.themeCore && window.themeCore.EventBus;
		if (bus && typeof bus.emit === 'function') {
			bus.emit('cart:refresh');
			bus.emit('cart:drawer:open');
		} else {
			window.location.href = '/cart';
		}
	}

	/* ----- Submit: intercetta in capture phase quando il ricamo è attivo ----- */
	function onSubmit(e) {
		var form = e.target;
		if (!form || form.nodeName !== 'FORM') return;
		if (!form.matches(PRODUCT_FORM_SELECTOR)) return;

		var block = getBlock(form);
		if (!block || !isActive(block)) return; // ricamo non attivo -> flusso normale del tema

		// Testo obbligatorio quando il ricamo è richiesto
		var required = block.getAttribute('data-ricamo-required') === 'true';
		var input = block.querySelector('.js-custom-field-input');
		if (required && input && input.value.trim() === '') {
			e.preventDefault();
			e.stopImmediatePropagation();
			showError(block);
			return;
		}

		var items = buildItems(form, block);
		if (!items) return; // nessuna variante selezionata -> lascia gestire al tema

		// Da qui in poi gestiamo noi: blocchiamo il submit del tema.
		e.preventDefault();
		e.stopImmediatePropagation();

		var btn = form.querySelector('[type="submit"], .js-product-add-button, button[name="add"]');
		if (btn) btn.setAttribute('disabled', 'disabled');

		fetch('/cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
			body: JSON.stringify({ items: items })
		})
			.then(function (r) {
				if (!r.ok) return r.json().then(function (j) { throw j; });
				return r.json();
			})
			.then(function () {
				refreshCart();
			})
			.catch(function (err) {
				var msg = (err && err.description) || 'Si è verificato un errore. Riprova.';
				window.alert(msg);
			})
			.then(function () {
				if (btn) btn.removeAttribute('disabled');
			});
	}

	/* ----- Bootstrap ----- */
	function initAll() {
		document.querySelectorAll('.js-custom-field-block').forEach(syncBlock);
	}

	// Toggle del ricamo
	document.addEventListener('change', function (e) {
		var t = e.target;
		if (t && t.classList && t.classList.contains('js-ricamo-toggle')) {
			syncBlock(t.closest('.js-custom-field-block'));
		}
	});

	// Intercettazione submit in CAPTURE phase (gira prima del tema)
	document.addEventListener('submit', onSubmit, true);

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	// I form possono essere iniettati dinamicamente (quick view, sezioni AJAX)
	new MutationObserver(initAll).observe(document.body, { childList: true, subtree: true });
})();
